import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import useUploadContext from "hooks/useUploadContext";
import { styled } from '@mui/material/styles';
import Speed_25_On from "assets/images/speed-0.25-on.png";
import Speed_25_Off from "assets/images/speed-0.25-off.png";
import Speed_50_On from "assets/images/speed-0.5-on.png";
import Speed_50_Off from "assets/images/speed-0.5-off.png";
import Speed_150_On from "assets/images/speed-1.5-on.png";
import Speed_150_Off from "assets/images/speed-1.5-off.png";
import Speed_200_On from "assets/images/speed-2-on.png";
import Speed_200_Off from "assets/images/speed-2-off.png";
import "./index.scss";

const SpeedButton = styled(Button)(() => ({
    height: '100%',
    boxSizing: 'border-box',
    padding: 0,
    margin: 0,
    borderRadius: 0,
    minWidth: 0,
    'img': {
        height: '90%',
    }
}));

const ActionBox = () => {
    const { time, totalTime, speed, setSpeed } = useUploadContext();
    const getTime = (value) => {
        const Hours = Math.floor(value / (60 * 60));
        const minutes = Math.floor(value / 60);
        const seconds = Math.floor((value % 60));
        return `${Hours}:${`0${minutes}`.slice(-2)}:${`0${seconds}`.slice(-2)}`
    }

    const handleSpeed = (i) => {
        setSpeed(speed === i ? 1 : i);
    };

    return (
        <Box className="timer-actions-component">
            <SpeedButton onClick={() => handleSpeed(0.25)}>
                <img
                    src={speed === 0.25 ? Speed_25_On : Speed_25_Off}
                    alt="Speed Button"
                />
            </SpeedButton>
            <SpeedButton onClick={() => handleSpeed(0.5)}>
                <img
                    src={speed === 0.5 ? Speed_50_On : Speed_50_Off}
                    alt="Speed Button"
                />
            </SpeedButton>
            <Box className="timer-box">
                {`${getTime(time)} / ${getTime(totalTime)}`}
            </Box>
            <SpeedButton onClick={() => handleSpeed(1.5)}>
                <img
                    src={speed === 1.5 ? Speed_150_On : Speed_150_Off}
                    alt="Speed Button"
                />
            </SpeedButton>
            <SpeedButton onClick={() => handleSpeed(2)}>
                <img
                    src={speed === 2 ? Speed_200_On : Speed_200_Off}
                    alt="Speed Button"
                />
            </SpeedButton>
        </Box>
    )
}

export default ActionBox;
